import styled from 'styled-components';

import { Box } from '../ui/Box';
import { theme } from '../ui/theme';

export const ButtonGroup = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.space[8]};
    flex-wrap: nowrap;
`;
